import { Document } from 'share/domain/document'

export enum DocumentStatus {
  Accepted,
  Approved,
  Pending,
  Rejected,
  Replaced,
  Review,
  Unknown
}

export const getDocumentStatus = (doc: Document | null): DocumentStatus => {
  if (doc && doc.status) {
    const statusString = doc.status as keyof typeof DocumentStatus
    return DocumentStatus[statusString]
  }

  return DocumentStatus.Unknown
}
